import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { ROUTES } from '../../../../../constants';
import { useToast } from '../../../../../services/toast';

export const AdobeAcrobatSignCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { addToast } = useToast();

  const errorMessage = searchParams.get('errorMessage') || null;

  useEffect(() => {
    if (errorMessage) {
      addToast({
        summary: `eSign Connection Failed`,
        detail: `There was an error connecting to eSign. Please try again.`,
        severity: 'error',
      });
    } else {
      addToast({
        summary: `eSign Connected`,
        detail: `eSign has been successfully connected.`,
        severity: 'info',
      });
    }

    navigate(ROUTES.SETTINGS_ESIGN, {});
  }, [addToast, errorMessage, navigate]);

  return null;
};
